<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "TemplateSchemaSettingsCollectionWrapper"
    }
</script>

<style scoped>

</style>